module.exports = {
  "name": "vanilla-typescript",
  "version": "1.0.0",
  "description": "JavaScript and TypeScript example starter project",
  "main": "index.html",
  "scripts": {
    "start": "parcel index.html",
    "dev": "npm run start",
    "build": "parcel build index.html --no-minify --public-url ./"
  },
  "devDependencies": {
    "@types/three": "^0.139.0",
    "@types/webgi": "https://storage.googleapis.com/dist.pixotronics.com/webgi/runtime/bundle-types-0.4.6.tgz",
    "parcel-bundler": "^1.6.1",
    "parcel-plugin-static-files-copy": "^2.6.0",
    "sass": "^1.54.0",
    "typescript": "4.4.4",
    "webgi": "https://storage.googleapis.com/dist.pixotronics.com/webgi/runtime/bundle-0.4.6.tgz"
  },
  "resolutions": {
    "@babel/preset-env": "7.13.8"
  },
  "keywords": [
    "typescript",
    "javascript"
  ],
  "staticFiles": {
    "staticPath": [
      {
        "staticPath": "assets",
        "staticOutDir": "assets"
      }
    ]
  },
  "dependencies": {
    "@studio-freight/lenis": "^0.2.24",
    "gsap": "^3.12.3",
    "tiny-emitter": "^2.1.0",
    "virtual-scroll": "2.2.1"
  }
}
;